import { UserLocationShare } from "@nova/protobuf"
import { useAppSelector } from "integrations/redux/hooks"
import store from "integrations/redux/store"
import { PluginSpec, staticIcon } from "plugins/plugin-registry"
import { selectOpenPlaybackIds } from "plugins/shared/playback/state/selectors"
import { openPlayback } from "plugins/shared/playback/state/slice"
import { useMemo } from "react"

export const getUseUserLocationShareMapNodes = (spec: PluginSpec<UserLocationShare>) => {
    const useUserLocationShareMapNodes = () => {
        const entities = useAppSelector(spec.selectAllEntities)
        const openPlaybackIds = useAppSelector(selectOpenPlaybackIds)
        return useMemo(
            () =>
                entities
                    .filter(
                        (entity) =>
                            !entity.live &&
                            !!entity.initialCoordinate &&
                            !openPlaybackIds.includes(entity.id)
                    )
                    .map((entity) => ({
                        id: entity.id,
                        position: {
                            lat: entity.initialCoordinate!.latitude,
                            lng: entity.initialCoordinate!.longitude,
                        },
                        visible: entity.visible,
                        locked: !!entity.locked,
                        active: false,
                        onClick: () =>
                            store.dispatch(openPlayback({ id: entity.id, type: "locationShare" })),
                        iconSrc: staticIcon({
                            default: "/icons/locationShare/default.svg",
                            hover: "/icons/locationShare/hover.svg",
                        }),
                    })),
            [entities, openPlaybackIds]
        )
    }
    return useUserLocationShareMapNodes
}
